import { useSyncExternalStore } from 'react'

// Реактивный флаг «показываем экран-поздравление онбординга».
// Нужен, потому что completeOnboarding сразу ставит onboardingCompleted=true и
// шлёт serverEvent profile.changed → useAuth.needsOnboarding мгновенно становится
// false → App.tsx размонтирует <Onboarding/> вместе с экраном-поздравлением
// (баг #178: «успех с персонажем моментально закрылся, стало „Подбираем куратора“»).
// Пока флаг true — App продолжает рендерить Onboarding, и поздравление держится
// до тапа «Перейти в приложение». Модульное состояние сбрасывается при перезагрузке
// мини-аппа, поэтому при повторном открытии экран-поздравление не залипает.
let completing = false
const listeners = new Set<() => void>()

export const onboardingCompleting = {
  get: () => completing,
  set: (v: boolean) => {
    if (completing === v) return
    completing = v
    listeners.forEach((l) => l())
  },
  subscribe: (l: () => void) => {
    listeners.add(l)
    return () => { listeners.delete(l) }
  },
}

export function useOnboardingCompleting(): boolean {
  return useSyncExternalStore(onboardingCompleting.subscribe, onboardingCompleting.get, () => false)
}
